import React from "react";
import { Box, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import DurationSelect from "./DurationSelect";

/**
 * Duration slider with aspect ratio stacked underneath (shared by Kling / generic panels).
 */
export default function DurationAspectRow({
  form,
  onChange,
  lang,
  modelId,
  aspectOptions,
  hideAspect = false,
}) {
  const set = (patch) => onChange({ ...form, ...patch });
  const options = aspectOptions || ["16:9", "9:16", "1:1"];

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Box sx={{ width: "100%", minWidth: 0 }}>
        <DurationSelect form={form} onChange={onChange} lang={lang} modelId={modelId} />
      </Box>

      {!hideAspect ? (
        <Box sx={{ width: "100%" }}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={600}
            sx={{ display: "block", mb: 0.5 }}
          >
            {lang?.videoStudioAspect || "Aspect ratio"}
          </Typography>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={form.aspectRatio}
            onChange={(_, v) => v && set({ aspectRatio: v })}
            sx={{ flexWrap: "wrap" }}
          >
            {options.map((a) => (
              <ToggleButton key={a} value={a} sx={{ minWidth: 48 }}>
                {a}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      ) : null}
    </Stack>
  );
}
